var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"not-found"}},[_c('h1',[_vm._v("404 - Page does not exist")]),_c('router-link',{staticClass:"link",attrs:{"to":"/"}},[_vm._v("Go back home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }